export class MedicationRequestForm {
    name = null;
    code = null;
    drugs = [];
    isActive = true;
    department = null;
    room = null
}